const SECTION =  {
    
    //Defined types of tab's content
    DEFINITION: 1,
    BOOK: 2,
    PHOTOS: 3,
    TEXT: 4
}

export default SECTION


// WEBPACK FOOTER //
// ./src/constants/section-types.js